/* ============================================================
   FRIESISCHE FEINKOST — KATEGORIESEITEN-RUNTIME
   Animationen, Filter, Sortierung, Schnellansicht, Warenkorb.
   - Ohne Fremdbibliotheken.
   - Inhalte sind ohne JavaScript sichtbar (JS ergaenzt nur den Startzustand).
   - Mehrfach ladbar und Theme-Editor-fest.
   - Beachtet prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';
  if (window.FFCat) { window.FFCat.init(); return; }

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var fxItems = [];
  var rafPending = false;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function on(el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o); }

  /* ============================================================
     ANIMATIONEN
     ============================================================ */
  var revObs = null;
  function getObs() {
    if (revObs || !('IntersectionObserver' in window)) return revObs;
    revObs = new IntersectionObserver(function (en, o) {
      en.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ffc-in'); o.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.02 });
    return revObs;
  }

  function initReveals(root) {
    var roots = $$('.ffc-root', root);
    if (root.classList && root.classList.contains('ffc-root')) roots.push(root);
    roots.forEach(function (r) { r.classList.add('ffc-js'); });
    if (!reduced) roots.forEach(function (r) { r.classList.add('ffc-js-anim'); });

    var targets = $$('.ffc-reveal, .ffc-mask, [data-ffc-split]', root);
    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('ffc-in'); });
      return;
    }
    var obs = getObs();
    targets.forEach(function (el) {
      if (el.dataset.ffcRev === '1') return;
      el.dataset.ffcRev = '1';
      if (el.hasAttribute('data-ffc-split')) splitWords(el);
      obs.observe(el);
    });
  }

  /* Ueberschrift in Woerter zerlegen — jedes Wort faehrt einzeln hoch */
  function splitWords(el) {
    if (el.dataset.ffcSplitDone === '1') return;
    el.dataset.ffcSplitDone = '1';
    var nodes = Array.prototype.slice.call(el.childNodes);
    el.innerHTML = '';
    function wrap(target, text) {
      text.split(/(\s+)/).forEach(function (w) {
        if (!w.trim()) { target.appendChild(document.createTextNode(w)); return; }
        var s = document.createElement('span');
        s.className = 'ffc-sw';
        var i = document.createElement('i');
        i.textContent = w;
        s.appendChild(i);
        target.appendChild(s);
      });
    }
    nodes.forEach(function (node) {
      if (node.nodeType === 3) {
        wrap(el, node.textContent);
      } else if (node.nodeType === 1) {
        var tag = node.cloneNode(false);
        wrap(tag, node.textContent || '');
        el.appendChild(tag);
      } else {
        el.appendChild(node);
      }
    });
  }

  /* FAQ: Startzustand setzen (ohne JS bleiben alle Antworten lesbar) */
  function initFaq(root) {
    $$('.ffc-faq-list', root).forEach(function (list) {
      if (list.dataset.ffcInit === '1') return;
      list.dataset.ffcInit = '1';
      $$('.ffc-faq-item', list).forEach(function (item, i) {
        var open = list.dataset.ffcOpenFirst === 'true' && i === 0;
        item.classList.toggle('ffc-open', open);
        var b = $('.ffc-faq-q', item);
        if (b) b.setAttribute('aria-expanded', String(open));
      });
    });
  }

  function registerFx(root) {
    $$('[data-ffc-parallax]', root).forEach(function (el) {
      if (el.dataset.ffcFx === '1') return;
      el.dataset.ffcFx = '1';
      if (reduced) return;
      fxItems.push({ el: el, amt: parseFloat(el.dataset.ffcParallax || '0') });
    });
    onScroll();
  }

  function onScroll() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      var vh = window.innerHeight || 1;
      for (var i = fxItems.length - 1; i >= 0; i--) {
        var it = fxItems[i];
        if (!it.el.isConnected) { fxItems.splice(i, 1); continue; }
        var r = it.el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) continue;
        var p = (vh - r.top) / (vh + r.height);
        p = Math.max(0, Math.min(1, p));
        it.el.style.transform = 'translate3d(0,' + ((p - 0.5) * it.amt).toFixed(2) + '%,0)';
      }
      $$('[data-ffc-progress]').forEach(function (bar) {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, (window.scrollY || 0) / h) : 0) + ')';
      });
    });
  }

  function initCounters(root) {
    $$('[data-ffc-count]', root).forEach(function (el) {
      if (el.dataset.ffcInit === '1') return;
      el.dataset.ffcInit = '1';
      var target = parseFloat(el.dataset.ffcCount) || 0;
      if (reduced || !('IntersectionObserver' in window)) { el.textContent = target; return; }
      var io = new IntersectionObserver(function (en, o) {
        en.forEach(function (e) {
          if (!e.isIntersecting) return;
          o.disconnect();
          var start = null, dur = 1500;
          function step(ts) {
            if (start === null) start = ts;
            var t = Math.min(1, (ts - start) / dur);
            el.textContent = Math.round(target * (1 - Math.pow(1 - t, 3)));
            if (t < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  function initMagnetic(root) {
    if (!fine || reduced) return;
    $$('.ffc-magnetic', root).forEach(function (el) {
      if (el.dataset.ffcMag === '1') return;
      el.dataset.ffcMag = '1';
      on(el, 'mousemove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.22) + 'px,' +
          ((e.clientY - r.top - r.height / 2) * 0.28) + 'px)';
      });
      on(el, 'mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ============================================================
     KATEGORIE-NAVIGATION
     ============================================================ */
  function initCatnav(root) {
    $$('[data-ffc-catnav]', root).forEach(function (nav) {
      var list = $('[data-ffc-catnav-list]', nav);
      var ind = $('[data-ffc-catnav-ind]', nav);
      var scroll = $('[data-ffc-catnav-scroll]', nav);
      if (!list || !ind || !scroll) return;

      function active() { return $('.ffc-active', list) || list.querySelector('a'); }
      function move(el) {
        if (!el) return;
        ind.style.width = el.offsetWidth + 'px';
        ind.style.transform = 'translateX(' + el.offsetLeft + 'px)';
      }
      function fades() {
        var l = $('.ffc-catnav-fade.ffc-l', nav), r = $('.ffc-catnav-fade.ffc-r', nav);
        if (l) l.classList.toggle('ffc-on', scroll.scrollLeft > 6);
        if (r) r.classList.toggle('ffc-on', scroll.scrollLeft + scroll.clientWidth < scroll.scrollWidth - 6);
      }
      nav.__ffcSync = function () { move(active()); fades(); };

      if (nav.dataset.ffcInit !== '1') {
        nav.dataset.ffcInit = '1';
        $$('a', list).forEach(function (a) {
          on(a, 'mouseenter', function () { move(a); });
          on(a, 'focus', function () { move(a); });
        });
        on(list, 'mouseleave', function () { move(active()); });
        on(scroll, 'scroll', fades, { passive: true });
      }
      nav.__ffcSync();
      var act = active();
      if (act && act.offsetLeft + act.offsetWidth > scroll.clientWidth) {
        scroll.scrollLeft = act.offsetLeft - 24;
      }
      setTimeout(nav.__ffcSync, 350);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(nav.__ffcSync).catch(function () { });
    });
  }

  /* ============================================================
     PRODUKTRASTER: FILTERN, SORTIEREN, ANZEIGEN
     ============================================================ */
  function initShop(root) {
    var shops = $$('[data-ffc-shop]', root);
    if (root.matches && root.matches('[data-ffc-shop]')) shops.push(root);
    shops.forEach(setupShop);
  }

  function setupShop(shop) {
    if (shop.dataset.ffcInit === '1') { if (shop.__ffcRender) shop.__ffcRender(false); return; }
    shop.dataset.ffcInit = '1';

    var grid = $('[data-ffc-grid]', shop);
    if (!grid) return;
    var feature = $('[data-ffc-feature]', shop);
    var perPage = parseInt(shop.dataset.ffcPerPage || '9', 10);
    var featureAfter = parseInt(shop.dataset.ffcFeatureAfter || '6', 10);
    var empty = $('[data-ffc-empty]', shop);

    var state = { sort: 'empfohlen', price: [], attr: [], inStock: false, page: perPage };

    function cards() { return $$('.ffc-card[data-ffc-card]', grid); }

    function matches(c) {
      if (state.inStock && c.dataset.ffcAvail === 'out') return false;
      if (state.price.length) {
        var p = parseInt(c.dataset.ffcPrice || '0', 10);
        var hit = state.price.some(function (r) {
          var a = r.split('-');
          return p >= parseInt(a[0], 10) && p < parseInt(a[1], 10);
        });
        if (!hit) return false;
      }
      if (state.attr.length) {
        var tags = ' ' + (c.dataset.ffcAttrs || '') + ' ';
        if (!state.attr.some(function (a) { return tags.indexOf(' ' + a + ' ') > -1; })) return false;
      }
      return true;
    }

    function sortKey(a, b) {
      switch (state.sort) {
        case 'preis-auf': return (+a.dataset.ffcPrice) - (+b.dataset.ffcPrice);
        case 'preis-ab': return (+b.dataset.ffcPrice) - (+a.dataset.ffcPrice);
        case 'name': return (a.dataset.ffcName || '').localeCompare(b.dataset.ffcName || '', 'de');
        case 'beliebt': return (+b.dataset.ffcRating - +a.dataset.ffcRating) || (+b.dataset.ffcReviews - +a.dataset.ffcReviews);
        default: return (+a.dataset.ffcRank) - (+b.dataset.ffcRank);
      }
    }

    function render(animate) {
      var all = cards();
      var visible = all.filter(matches).sort(sortKey);

      all.forEach(function (c) { c.style.display = 'none'; c.style.order = ''; });
      visible.slice(0, state.page).forEach(function (c, i) {
        c.style.display = '';
        c.style.order = (i + 1) * 10;
        if (!c.classList.contains('ffc-in')) {
          if (reduced || animate === false) c.classList.add('ffc-in');
          else {
            c.style.transitionDelay = (Math.min(i, 11) * 0.05) + 's';
            requestAnimationFrame(function () { c.classList.add('ffc-in'); });
          }
        }
      });

      if (feature) {
        var shown = Math.min(visible.length, state.page);
        if (shown >= 3) {
          feature.style.display = '';
          feature.style.order = (shown >= featureAfter ? featureAfter * 10 + 5 : shown * 10 + 5);
          feature.classList.add('ffc-in');
        } else {
          feature.style.display = 'none';
        }
      }

      var vis = $('[data-ffc-vis]', shop), tot = $('[data-ffc-total]', shop);
      if (vis) vis.textContent = Math.min(visible.length, state.page);
      if (tot) tot.textContent = all.length;
      if (empty) empty.hidden = visible.length > 0;

      var lm = $('[data-ffc-loadmore]', shop);
      if (lm) lm.parentNode.style.display = visible.length > state.page ? '' : 'none';

      syncUI();
      initMagnetic(grid);
    }
    shop.__ffcRender = render;

    function busy() {
      if (reduced) { render(false); return; }
      grid.classList.add('ffc-is-busy');
      setTimeout(function () { render(false); grid.classList.remove('ffc-is-busy'); }, 200);
    }

    function labelFor(f, v) {
      var el = $('[data-ffc-facet="' + f + '"][value="' + v + '"]', shop);
      return (el && (el.dataset.ffcLabel || el.textContent.replace('✓', '').trim())) || v;
    }

    function pill(f, v, l) {
      return '<button class="ffc-pill-x" data-ffc-remove="' + f + '" value="' + v + '">' + l +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M18 6 6 18M6 6l12 12"/></svg></button>';
    }

    function syncUI() {
      $$('[data-ffc-facet]', shop).forEach(function (el) {
        var f = el.dataset.ffcFacet, v = el.getAttribute('value') || el.value, isOn = false;
        if (f === 'stock') isOn = state.inStock;
        if (f === 'price') isOn = state.price.indexOf(v) > -1;
        if (f === 'attr') isOn = state.attr.indexOf(v) > -1;
        if (el.tagName === 'INPUT') el.checked = isOn; else el.classList.toggle('ffc-on', isOn);
      });
      $$('[data-ffc-sort-chip]', shop).forEach(function (b) {
        b.classList.toggle('ffc-on', b.dataset.ffcSortChip === state.sort);
      });
      var sel = $('[data-ffc-sort]', shop);
      if (sel) sel.value = state.sort;

      var n = state.price.length + state.attr.length + (state.inStock ? 1 : 0);
      var badge = $('[data-ffc-badge]', shop);
      if (badge) { badge.textContent = n; badge.classList.toggle('ffc-on', n > 0); }

      var wrap = $('[data-ffc-active-facets]', shop);
      if (!wrap) return;
      wrap.innerHTML = '';
      if (state.inStock) wrap.insertAdjacentHTML('beforeend', pill('stock', 'in', labelFor('stock', 'in')));
      state.price.forEach(function (v) { wrap.insertAdjacentHTML('beforeend', pill('price', v, labelFor('price', v))); });
      state.attr.forEach(function (v) { wrap.insertAdjacentHTML('beforeend', pill('attr', v, labelFor('attr', v))); });
    }

    function toggle(f, v) {
      if (f === 'stock') state.inStock = !state.inStock;
      else {
        var arr = state[f], i = arr.indexOf(v);
        if (i > -1) arr.splice(i, 1); else arr.push(v);
      }
      state.page = perPage;
      busy();
    }

    function clearAll() {
      state.price = []; state.attr = []; state.inStock = false; state.sort = 'empfohlen'; state.page = perPage;
      busy();
    }

    on(shop, 'click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var chip = t.closest('[data-ffc-facet]');
      if (chip && chip.tagName !== 'INPUT') {
        e.preventDefault();
        toggle(chip.dataset.ffcFacet, chip.getAttribute('value'));
        return;
      }
      var rm = t.closest('[data-ffc-remove]');
      if (rm) { toggle(rm.dataset.ffcRemove, rm.getAttribute('value')); return; }

      var sc = t.closest('[data-ffc-sort-chip]');
      if (sc) { state.sort = sc.dataset.ffcSortChip; state.page = perPage; busy(); return; }

      if (t.closest('[data-ffc-clear]')) { clearAll(); return; }

      var col = t.closest('[data-ffc-cols]');
      if (col) {
        grid.style.setProperty('--cols', col.dataset.ffcCols);
        $$('[data-ffc-cols]', shop).forEach(function (b) {
          b.classList.toggle('ffc-on', b === col);
          b.setAttribute('aria-pressed', b === col ? 'true' : 'false');
        });
        return;
      }

      if (t.closest('[data-ffc-loadmore]')) { state.page += perPage; render(true); return; }

      if (t.closest('[data-ffc-open-filters]')) { openDrawer(shop); return; }
      if (t.closest('[data-ffc-close-filters]') || t.closest('[data-ffc-drawer-apply]') ||
          (t.dataset && t.dataset.ffcDrawerOverlay !== undefined)) { closeDrawer(shop); return; }
      if (t.closest('[data-ffc-drawer-clear]')) { clearAll(); return; }
    });

    on(shop, 'change', function (e) {
      var t = e.target;
      if (t.matches('[data-ffc-sort]')) { state.sort = t.value; state.page = perPage; busy(); return; }
      if (t.matches('[data-ffc-facet="stock"]')) { toggle('stock', 'in'); return; }
    });

    render(false);
  }

  function openDrawer(shop) {
    var d = $('[data-ffc-drawer]', shop), o = $('[data-ffc-drawer-overlay]', shop);
    if (!d) return;
    d.classList.add('ffc-open');
    if (o) o.classList.add('ffc-open');
    document.body.classList.add('ffc-no-scroll');
    var close = $('[data-ffc-close-filters]', d);
    if (close) close.focus();
  }

  function closeDrawer(shop) {
    var d = $('[data-ffc-drawer]', shop), o = $('[data-ffc-drawer-overlay]', shop);
    if (d) d.classList.remove('ffc-open');
    if (o) o.classList.remove('ffc-open');
    document.body.classList.remove('ffc-no-scroll');
  }

  /* ============================================================
     BEWERTUNGS-KARUSSELL
     ============================================================ */
  function initReviews(root) {
    $$('[data-ffc-rv]', root).forEach(function (wrap) {
      var track = $('[data-ffc-rv-track]', wrap);
      var dots = $('[data-ffc-rv-dots]', wrap);
      if (!track) return;
      var idx = 0, timer = null, x0 = null;
      var count = track.children.length;

      function per() { return window.innerWidth <= 640 ? 1 : (window.innerWidth <= 900 ? 2 : 3); }
      function max() { return Math.max(0, count - per()); }
      function go(i) {
        idx = Math.max(0, Math.min(max(), i));
        var card = track.children[0];
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).gap) || 22;
        track.style.transform = 'translateX(' + (-(card.offsetWidth + gap) * idx) + 'px)';
        if (dots) Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('ffc-on', j === idx); });
      }
      function buildDots() {
        if (!dots) return;
        dots.innerHTML = '';
        for (var i = 0; i <= max(); i++) {
          (function (i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Bewertung ' + (i + 1) + ' anzeigen');
            if (i === idx) b.classList.add('ffc-on');
            b.addEventListener('click', function () { go(i); restart(); });
            dots.appendChild(b);
          })(i);
        }
      }
      function restart() {
        if (timer) clearInterval(timer);
        if (reduced || count <= per() || wrap.dataset.ffcAutoplay === 'false') return;
        timer = setInterval(function () { go(idx >= max() ? 0 : idx + 1); }, parseInt(wrap.dataset.ffcInterval || '6000', 10));
      }
      wrap.__ffcSync = function () { buildDots(); go(idx); };

      if (wrap.dataset.ffcInit !== '1') {
        wrap.dataset.ffcInit = '1';
        on($('[data-ffc-rv-prev]', wrap), 'click', function () { go(idx - 1); restart(); });
        on($('[data-ffc-rv-next]', wrap), 'click', function () { go(idx + 1); restart(); });
        on(wrap, 'mouseenter', function () { if (timer) clearInterval(timer); });
        on(wrap, 'mouseleave', restart);
        on(track, 'touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        on(track, 'touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 45) go(idx + (dx < 0 ? 1 : -1));
          x0 = null; restart();
        }, { passive: true });
      }
      wrap.__ffcSync();
      restart();
    });
  }

  /* ============================================================
     EMPFEHLUNGS-RAIL
     ============================================================ */
  function initRecos(root) {
    $$('[data-ffc-reco]', root).forEach(function (wrap) {
      if (wrap.dataset.ffcInit === '1') return;
      wrap.dataset.ffcInit = '1';
      var section = wrap.closest('[data-ffc-section]') || document;
      var rail = $('[data-ffc-reco-rail]', section);
      if (!rail) return;
      function step(dir) {
        var card = rail.querySelector('.ffc-card');
        if (!card) return;
        var gap = parseFloat(getComputedStyle(rail).gap) || 22;
        rail.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: reduced ? 'auto' : 'smooth' });
      }
      on($('[data-ffc-reco-prev]', wrap), 'click', function () { step(-1); });
      on($('[data-ffc-reco-next]', wrap), 'click', function () { step(1); });
    });
  }

  /* ============================================================
     WARENKORB / MELDUNGEN / SCHNELLANSICHT
     ============================================================ */
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function toast(msg, linkHtml) {
    var t = $('#ffc-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'ffc-toast';
      t.className = 'ffc-root ffc-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.innerHTML = '<span class="ffc-tick-circle"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6 9 17l-5-5"/></svg></span><span id="ffc-toast-msg"></span>';
      document.body.appendChild(t);
    }
    $('#ffc-toast-msg', t).innerHTML = (msg || '') + (linkHtml || '');
    t.classList.add('ffc-show');
    clearTimeout(window.__ffcToast);
    window.__ffcToast = setTimeout(function () { t.classList.remove('ffc-show'); }, 3600);
  }

  function notifyCart() {
    ['cart:refresh', 'cart:update', 'cart-update', 'cartUpdated'].forEach(function (n) {
      document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { source: 'ff-category' } }));
    });
    fetch(cartRoot() + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('.cart-count-bubble span:first-child, [data-cart-count], .cart-count').forEach(function (el) {
          if (/^\s*\d+\s*$/.test(el.textContent)) el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('ff:cart:updated', { bubbles: true, detail: cart }));
      })
      .catch(function () { });
  }

  function addToCart(variantId, qty, name, btn) {
    if (!variantId) return;
    var root = cartRoot();
    if (btn) btn.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(qty) || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) btn.disabled = false;
        if (!res.ok) { toast((res.data && res.data.description) || 'Artikel konnte nicht hinzugefügt werden.'); return; }
        if (btn) { btn.classList.add('ffc-done'); setTimeout(function () { btn.classList.remove('ffc-done'); }, 1400); }
        toast((name || 'Artikel') + ' hinzugefügt. ', '<a href="' + root + 'cart">Warenkorb ansehen</a>');
        notifyCart();
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        window.location.href = root + 'cart/' + variantId + ':' + (qty || 1);
      });
  }

  function cardData(card) {
    if (card.__ffcData) return card.__ffcData;
    var s = $('[data-ffc-product-json]', card);
    if (!s) return null;
    try { card.__ffcData = JSON.parse(s.textContent); } catch (e) { card.__ffcData = null; }
    return card.__ffcData;
  }

  function qvFor(card) {
    var sec = card.closest('[data-ffc-section]');
    return (sec && $('[data-ffc-qv]', sec)) || $('[data-ffc-qv]');
  }

  function starSvg(n) {
    var s = '';
    for (var i = 1; i <= 5; i++) {
      s += '<svg width="13" height="13" viewBox="0 0 24 24" fill="' + (i <= Math.round(n) ? 'currentColor' : 'none') +
        '" stroke="currentColor" stroke-width="1.4"><path d="m12 2 2.9 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l7.1-1.01Z"/></svg>';
    }
    return s;
  }

  function fillQv(qv, d, i) {
    if (!d) return;
    var v = d.variants[i] || d.variants[0] || {};
    qv.dataset.ffcIdx = i;
    var img = $('[data-ffc-qv-img]', qv);
    if (img) { img.src = v.img || d.image || ''; img.alt = d.title || ''; }
    function set(sel, val) { var el = $(sel, qv); if (el) el.textContent = val || ''; }
    set('[data-ffc-qv-cat]', d.type);
    set('[data-ffc-qv-title]', d.title);
    set('[data-ffc-qv-desc]', d.desc);
    set('[data-ffc-qv-price]', v.price);
    set('[data-ffc-qv-unit]', v.unit);
    var was = $('[data-ffc-qv-was]', qv);
    if (was) { was.textContent = v.compare || ''; was.style.display = v.compare ? '' : 'none'; }
    var stars = $('[data-ffc-qv-stars]', qv);
    if (stars) stars.innerHTML = d.rating ? starSvg(d.rating) : '';
    var specs = $('[data-ffc-qv-specs]', qv);
    if (specs) {
      specs.innerHTML = (d.specs || []).filter(Boolean).map(function (s) {
        return '<li>' + s + '</li>';
      }).join('');
    }
    var sizes = $('[data-ffc-qv-sizes]', qv);
    if (sizes) {
      sizes.innerHTML = '';
      if (d.variants.length > 1) {
        d.variants.forEach(function (vv, j) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ffc-chip' + (j === i ? ' ffc-on' : '');
          b.textContent = vv.title;
          b.dataset.ffcQvSize = j;
          if (!vv.available) b.disabled = true;
          sizes.appendChild(b);
        });
      }
    }
    var add = $('[data-ffc-qv-add]', qv);
    if (add) { add.dataset.ffcVariantId = v.id; add.disabled = !v.available; }
    var link = $('[data-ffc-qv-link]', qv);
    if (link) link.href = d.url || '#';
    var q = $('[data-ffc-qv-qty]', qv);
    if (q) q.textContent = '1';
  }

  function openQv(card) {
    if (!card) return;
    var d = cardData(card), qv = qvFor(card);
    if (!d || !qv) return;
    qv.__ffcData = d;
    qv.__ffcCard = card;
    fillQv(qv, d, parseInt(card.dataset.ffcVariant || '0', 10));
    qv.classList.add('ffc-open');
    document.body.classList.add('ffc-no-scroll');
    var c = $('[data-ffc-qv-close]', qv);
    if (c) c.focus();
  }

  function closeQv(qv) {
    if (!qv) qv = $('[data-ffc-qv].ffc-open');
    if (!qv) return;
    qv.classList.remove('ffc-open');
    document.body.classList.remove('ffc-no-scroll');
  }

  function applyVariant(card, i) {
    var d = cardData(card);
    if (!d || !d.variants[i]) return;
    var v = d.variants[i];
    card.dataset.ffcVariant = i;
    function set(sel, val) { var el = $(sel, card); if (el) el.textContent = val || ''; }
    set('[data-ffc-price]', v.price);
    var was = $('[data-ffc-price-was]', card);
    if (was) { was.textContent = v.compare || ''; was.style.display = v.compare ? '' : 'none'; }
    var img = $('[data-ffc-img]', card);
    if (img && v.img && img.getAttribute('src') !== v.img) {
      img.style.opacity = '0';
      setTimeout(function () { img.removeAttribute('srcset'); img.src = v.img; img.style.opacity = '1'; }, 150);
    }
    var btn = $('[data-ffc-add]', card);
    if (btn) {
      btn.dataset.ffcVariantId = v.id;
      btn.disabled = !v.available;
      var lbl = $('[data-ffc-add-label]', btn);
      if (lbl) lbl.textContent = v.available ? (btn.dataset.ffcLabel || 'In den Warenkorb') : (btn.dataset.ffcSoldOut || 'Ausverkauft');
    }
  }

  /* ============================================================
     GLOBALE, DELEGIERTE EREIGNISSE
     ============================================================ */
  function bindGlobal() {
    if (document.documentElement.dataset.ffcBound === '1') return;
    document.documentElement.dataset.ffcBound = '1';

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      /* FAQ-Akkordeon */
      var q = t.closest('.ffc-faq-q');
      if (q) {
        var item = q.closest('.ffc-faq-item');
        var list = item.closest('.ffc-faq-list');
        var isOpen = item.classList.contains('ffc-open');
        if (list && list.dataset.ffcSingle !== 'false') {
          $$('.ffc-faq-item.ffc-open', list).forEach(function (o) {
            if (o === item) return;
            o.classList.remove('ffc-open');
            var b = $('.ffc-faq-q', o); if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('ffc-open', !isOpen);
        q.setAttribute('aria-expanded', String(!isOpen));
        return;
      }

      /* Mengensteuerung */
      var step = t.closest('[data-ffc-step]');
      if (step) {
        var box = step.closest('[data-ffc-qty-box]') || step.closest('[data-ffc-qv]');
        var out = box && ($('[data-ffc-qty]', box) || $('[data-ffc-qv-qty]', box));
        if (out) {
          var cur = parseInt(out.textContent, 10) || 1;
          out.textContent = Math.min(20, Math.max(1, cur + parseInt(step.dataset.ffcStep, 10)));
        }
        return;
      }

      /* In den Warenkorb (Karte) */
      var add = t.closest('[data-ffc-add]');
      if (add) {
        e.preventDefault();
        var card = add.closest('.ffc-card');
        var qty = card ? $('[data-ffc-qty]', card) : null;
        var d = card ? cardData(card) : null;
        addToCart(add.dataset.ffcVariantId, qty ? qty.textContent : 1, d ? d.title : '', add);
        return;
      }

      /* In den Warenkorb (hervorgehobenes Produkt) */
      var addF = t.closest('[data-ffc-add-simple]');
      if (addF) {
        e.preventDefault();
        addToCart(addF.dataset.ffcVariantId, 1, addF.dataset.ffcName, addF);
        return;
      }

      /* Schnellansicht */
      var qvBtn = t.closest('[data-ffc-quickview]');
      if (qvBtn) { e.preventDefault(); openQv(qvBtn.closest('.ffc-card')); return; }

      var qvSize = t.closest('[data-ffc-qv-size]');
      if (qvSize && !qvSize.disabled) {
        var qv = qvSize.closest('[data-ffc-qv]');
        var i = parseInt(qvSize.dataset.ffcQvSize, 10);
        fillQv(qv, qv.__ffcData, i);
        if (qv.__ffcCard) applyVariant(qv.__ffcCard, i);
        return;
      }

      var qvAdd = t.closest('[data-ffc-qv-add]');
      if (qvAdd) {
        e.preventDefault();
        var qv2 = qvAdd.closest('[data-ffc-qv]');
        var q2 = $('[data-ffc-qv-qty]', qv2);
        addToCart(qvAdd.dataset.ffcVariantId, q2 ? q2.textContent : 1, qv2.__ffcData ? qv2.__ffcData.title : '', qvAdd);
        return;
      }

      if (t.closest('[data-ffc-qv-close]')) { closeQv(t.closest('[data-ffc-qv]')); return; }
      if (t.dataset && t.dataset.ffcQv !== undefined) { closeQv(t); return; }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeQv();
      $$('[data-ffc-shop]').forEach(closeDrawer);
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      onScroll();
      $$('[data-ffc-catnav]').forEach(function (n) { if (n.__ffcSync) n.__ffcSync(); });
      $$('[data-ffc-rv]').forEach(function (r) { if (r.__ffcSync) r.__ffcSync(); });
    }, { passive: true });
    window.addEventListener('load', function () {
      $$('[data-ffc-catnav]').forEach(function (n) { if (n.__ffcSync) n.__ffcSync(); });
    });
  }

  /* ============================================================
     START
     ============================================================ */
  function init(scope) {
    var root = scope || document;
    bindGlobal();
    initReveals(root);
    initFaq(root);
    registerFx(root);
    initCounters(root);
    initMagnetic(root);
    initCatnav(root);
    initShop(root);
    initReviews(root);
    initRecos(root);
  }

  window.FFCat = { init: init, toast: toast, addToCart: addToCart };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }

  /* Sicherheitsnetz: nichts darf dauerhaft unsichtbar bleiben */
  setTimeout(function () {
    $$('.ffc-reveal:not(.ffc-in), .ffc-mask:not(.ffc-in), [data-ffc-split]:not(.ffc-in)')
      .forEach(function (el) { el.classList.add('ffc-in'); });
  }, 4500);

  /* Theme-Editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function () {
    fxItems = fxItems.filter(function (i) { return i.el.isConnected; });
  });
})();